(function () {
  function closeMenu(header) {
    var toggle = header.querySelector('.cd-menu-toggle');
    header.classList.remove('cd-menu-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.cd-menu-toggle');
    if (!toggle) return;

    var header = toggle.closest('.cd-header');
    if (!header) return;

    var willOpen = !header.classList.contains('cd-menu-open');
    header.classList.toggle('cd-menu-open', willOpen);
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cd-header.cd-menu-open').forEach(closeMenu);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.cd-nav__link');
    if (!link) return;
    var header = link.closest('.cd-header');
    if (header) closeMenu(header);
  });
})();
